import type { PalletPatternLookupRow } from './formulas';

export const PALLET_PATTERN_LOOKUP: PalletPatternLookupRow[] = [
  {
    "palletType": "36x36x5",
    "caseLength": 10.0,
    "caseWidth": 7.0,
    "casesPerLayer": 16.0,
    "palletPattern": "Split Pin Wheel",
    "count": 1,
    "lengthStart": 9.5,
    "lengthEnd": 10.5,
    "widthStart": 6.5,
    "widthEnd": 7.5
  },
  {
    "palletType": "36x36x5",
    "caseLength": 10.0,
    "caseWidth": 8.0,
    "casesPerLayer": 16.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 9.5,
    "lengthEnd": 10.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "36x36x5",
    "caseLength": 12.0,
    "caseWidth": 12.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 11.5,
    "lengthEnd": 12.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "36x36x5",
    "caseLength": 14.0,
    "caseWidth": 10.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Pin Wheel",
    "count": 2,
    "lengthStart": 13.5,
    "lengthEnd": 14.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "36x36x5",
    "caseLength": 15.0,
    "caseWidth": 10.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Pin Wheel",
    "count": 7,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "36x36x5",
    "caseLength": 15.0,
    "caseWidth": 12.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Pin Wheel",
    "count": 5,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "36x36x5",
    "caseLength": 16.0,
    "caseWidth": 5.0,
    "casesPerLayer": 16.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 4.5,
    "widthEnd": 5.5
  },
  {
    "palletType": "36x36x5",
    "caseLength": 16.0,
    "caseWidth": 10.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Pin Wheel",
    "count": 5,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "36x36x5",
    "caseLength": 16.0,
    "caseWidth": 10.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 1,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "36x36x5",
    "caseLength": 17.0,
    "caseWidth": 10.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "36x36x5",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 6.0,
    "palletPattern": "Row",
    "count": 1,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "36x36x5",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 7.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "36x36x5",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Pin Wheel",
    "count": 6,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "36x36x5",
    "caseLength": 17.0,
    "caseWidth": 12.0,
    "casesPerLayer": 6.0,
    "palletPattern": "Row",
    "count": 6,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "36x36x5",
    "caseLength": 17.0,
    "caseWidth": 12.0,
    "casesPerLayer": 7.0,
    "palletPattern": "Split Row",
    "count": 4,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "36x36x5",
    "caseLength": 18.0,
    "caseWidth": 11.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "36x36x5",
    "caseLength": 19.0,
    "caseWidth": 10.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Pin Wheel",
    "count": 9,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "36x36x5",
    "caseLength": 19.0,
    "caseWidth": 12.0,
    "casesPerLayer": 6.0,
    "palletPattern": "Row",
    "count": 15,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "36x36x5",
    "caseLength": 19.0,
    "caseWidth": 13.0,
    "casesPerLayer": 6.0,
    "palletPattern": "Row",
    "count": 2,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 12.5,
    "widthEnd": 13.5
  },
  {
    "palletType": "37x37x5",
    "caseLength": 12.0,
    "caseWidth": 9.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 11.5,
    "lengthEnd": 12.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "37x37x5",
    "caseLength": 15.0,
    "caseWidth": 12.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "37x37x5",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "37x37x5",
    "caseLength": 19.0,
    "caseWidth": 10.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "37x37x5",
    "caseLength": 19.0,
    "caseWidth": 12.0,
    "casesPerLayer": 6.0,
    "palletPattern": "Row",
    "count": 3,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 10.0,
    "caseWidth": 8.0,
    "casesPerLayer": 18.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 9.5,
    "lengthEnd": 10.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 13.0,
    "caseWidth": 8.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 12.5,
    "lengthEnd": 13.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 15.0,
    "caseWidth": 10.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 4,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 15.0,
    "caseWidth": 10.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 3,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 15.0,
    "caseWidth": 12.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 15.0,
    "caseWidth": 12.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 15.0,
    "caseWidth": 12.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 1,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 15.0,
    "caseWidth": 12.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 3,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 16.0,
    "caseWidth": 5.0,
    "casesPerLayer": 18.0,
    "palletPattern": "Split Pin Wheel",
    "count": 2,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 4.5,
    "widthEnd": 5.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 16.0,
    "caseWidth": 10.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 17.0,
    "caseWidth": 10.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 1,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 7.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 4,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 2,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 17.0,
    "caseWidth": 12.0,
    "casesPerLayer": 7.0,
    "palletPattern": "Split Row",
    "count": 9,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 17.0,
    "caseWidth": 12.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 1,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 18.0,
    "caseWidth": 9.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 18.0,
    "caseWidth": 11.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Pin Wheel",
    "count": 2,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 19.0,
    "caseWidth": 10.0,
    "casesPerLayer": 7.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 19.0,
    "caseWidth": 10.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Pin Wheel",
    "count": 2,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 19.0,
    "caseWidth": 10.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 3,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 19.0,
    "caseWidth": 12.0,
    "casesPerLayer": 7.0,
    "palletPattern": "Split Row",
    "count": 25,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "42x36x5",
    "caseLength": 19.0,
    "caseWidth": 13.0,
    "casesPerLayer": 7.0,
    "palletPattern": "Split Row",
    "count": 5,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 12.5,
    "widthEnd": 13.5
  },
  {
    "palletType": "43x36x5",
    "caseLength": 19.0,
    "caseWidth": 12.0,
    "casesPerLayer": 7.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "43x37x5",
    "caseLength": 15.0,
    "caseWidth": 12.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "43x37x5",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "43x37x5",
    "caseLength": 18.0,
    "caseWidth": 11.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "43x37x5",
    "caseLength": 19.0,
    "caseWidth": 10.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "43x37x5",
    "caseLength": 19.0,
    "caseWidth": 12.0,
    "casesPerLayer": 7.0,
    "palletPattern": "Split Row",
    "count": 5,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "43x37x5",
    "caseLength": 19.0,
    "caseWidth": 13.0,
    "casesPerLayer": 7.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 12.5,
    "widthEnd": 13.5
  },
  {
    "palletType": "45x39.8x5.2",
    "caseLength": 15.0,
    "caseWidth": 10.0,
    "casesPerLayer": 15.0,
    "palletPattern": "Row",
    "count": 1,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "47x35x5",
    "caseLength": 15.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "47x35x5",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 3,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "47x35x5",
    "caseLength": 18.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "47x36x5",
    "caseLength": 12.0,
    "caseWidth": 8.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 1,
    "lengthStart": 11.5,
    "lengthEnd": 12.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "47x36x5",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "47x36x5",
    "caseLength": 19.0,
    "caseWidth": 12.0,
    "casesPerLayer": 7.0,
    "palletPattern": "Split Row",
    "count": 3,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 10.0,
    "caseWidth": 8.0,
    "casesPerLayer": 20.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 9.5,
    "lengthEnd": 10.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 10.0,
    "caseWidth": 8.0,
    "casesPerLayer": 24.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 9.5,
    "lengthEnd": 10.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 14.0,
    "caseWidth": 9.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 13.5,
    "lengthEnd": 14.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 15.0,
    "caseWidth": 9.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 2,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 15.0,
    "caseWidth": 10.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 6,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 15.0,
    "caseWidth": 10.0,
    "casesPerLayer": 13.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 15.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 3,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 15.0,
    "caseWidth": 11.0,
    "casesPerLayer": 11.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 15.0,
    "caseWidth": 12.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 16.0,
    "caseWidth": 5.0,
    "casesPerLayer": 20.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 4.5,
    "widthEnd": 5.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 16.0,
    "caseWidth": 10.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 8,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 16.0,
    "caseWidth": 10.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 3,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 17.0,
    "caseWidth": 10.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 7,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 17.0,
    "caseWidth": 12.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 8,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 18.0,
    "caseWidth": 9.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 2,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 18.0,
    "caseWidth": 9.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 18.0,
    "caseWidth": 11.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 18.0,
    "caseWidth": 11.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 1,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 18.0,
    "caseWidth": 11.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Row",
    "count": 4,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 18.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 19.0,
    "caseWidth": 10.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Pin Wheel",
    "count": 2,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 19.0,
    "caseWidth": 10.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 2,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 19.0,
    "caseWidth": 10.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 19.0,
    "caseWidth": 10.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 7,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 19.0,
    "caseWidth": 12.0,
    "casesPerLayer": 7.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 19.0,
    "caseWidth": 12.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 25,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 19.0,
    "caseWidth": 13.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Row",
    "count": 1,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 12.5,
    "widthEnd": 13.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 19.0,
    "caseWidth": 13.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 10,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 12.5,
    "widthEnd": 13.5
  },
  {
    "palletType": "48x36x5",
    "caseLength": 20.0,
    "caseWidth": 10.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 19.5,
    "lengthEnd": 20.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x37x5",
    "caseLength": 10.0,
    "caseWidth": 6.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 9.5,
    "lengthEnd": 10.5,
    "widthStart": 5.5,
    "widthEnd": 6.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 10.0,
    "caseWidth": 5.0,
    "casesPerLayer": 20.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 9.5,
    "lengthEnd": 10.5,
    "widthStart": 4.5,
    "widthEnd": 5.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 10.0,
    "caseWidth": 5.0,
    "casesPerLayer": 40.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 9.5,
    "lengthEnd": 10.5,
    "widthStart": 4.5,
    "widthEnd": 5.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 10.0,
    "caseWidth": 7.0,
    "casesPerLayer": 22.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 9.5,
    "lengthEnd": 10.5,
    "widthStart": 6.5,
    "widthEnd": 7.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 10.0,
    "caseWidth": 7.0,
    "casesPerLayer": 28.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 9.5,
    "lengthEnd": 10.5,
    "widthStart": 6.5,
    "widthEnd": 7.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 10.0,
    "caseWidth": 8.0,
    "casesPerLayer": 20.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 9.5,
    "lengthEnd": 10.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 10.0,
    "caseWidth": 8.0,
    "casesPerLayer": 24.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 9.5,
    "lengthEnd": 10.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 10.0,
    "caseWidth": 8.0,
    "casesPerLayer": 26.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 9.5,
    "lengthEnd": 10.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 11.0,
    "caseWidth": 7.0,
    "casesPerLayer": 25.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 10.5,
    "lengthEnd": 11.5,
    "widthStart": 6.5,
    "widthEnd": 7.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 11.0,
    "caseWidth": 8.0,
    "casesPerLayer": 19.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 10.5,
    "lengthEnd": 11.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 11.0,
    "caseWidth": 8.0,
    "casesPerLayer": 19.0,
    "palletPattern": "Split Pin Wheel",
    "count": 1,
    "lengthStart": 10.5,
    "lengthEnd": 11.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 11.0,
    "caseWidth": 8.0,
    "casesPerLayer": 20.0,
    "palletPattern": "Pin Wheel",
    "count": 3,
    "lengthStart": 10.5,
    "lengthEnd": 11.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 11.0,
    "caseWidth": 8.0,
    "casesPerLayer": 22.0,
    "palletPattern": "Pin Wheel",
    "count": 4,
    "lengthStart": 10.5,
    "lengthEnd": 11.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 11.0,
    "caseWidth": 8.0,
    "casesPerLayer": 26.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 10.5,
    "lengthEnd": 11.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 12.0,
    "caseWidth": 9.0,
    "casesPerLayer": 17.0,
    "palletPattern": "Split Row",
    "count": 5,
    "lengthStart": 11.5,
    "lengthEnd": 12.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 12.0,
    "caseWidth": 9.0,
    "casesPerLayer": 18.0,
    "palletPattern": "Split Row",
    "count": 3,
    "lengthStart": 11.5,
    "lengthEnd": 12.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 12.0,
    "caseWidth": 9.0,
    "casesPerLayer": 24.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 11.5,
    "lengthEnd": 12.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 12.0,
    "caseWidth": 12.0,
    "casesPerLayer": 12.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 11.5,
    "lengthEnd": 12.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 13.0,
    "caseWidth": 8.0,
    "casesPerLayer": 15.0,
    "palletPattern": "Split Block",
    "count": 2,
    "lengthStart": 12.5,
    "lengthEnd": 13.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 13.0,
    "caseWidth": 9.0,
    "casesPerLayer": 16.0,
    "palletPattern": "Split Pin Wheel",
    "count": 1,
    "lengthStart": 12.5,
    "lengthEnd": 13.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 13.0,
    "caseWidth": 9.0,
    "casesPerLayer": 16.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 12.5,
    "lengthEnd": 13.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 14.0,
    "caseWidth": 7.0,
    "casesPerLayer": 21.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 13.5,
    "lengthEnd": 14.5,
    "widthStart": 6.5,
    "widthEnd": 7.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 14.0,
    "caseWidth": 9.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 13.5,
    "lengthEnd": 14.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 14.0,
    "caseWidth": 9.0,
    "casesPerLayer": 13.0,
    "palletPattern": "Split Pin Wheel",
    "count": 1,
    "lengthStart": 13.5,
    "lengthEnd": 14.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 14.0,
    "caseWidth": 11.0,
    "casesPerLayer": 11.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 13.5,
    "lengthEnd": 14.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 14.0,
    "caseWidth": 11.0,
    "casesPerLayer": 12.0,
    "palletPattern": "Row",
    "count": 1,
    "lengthStart": 13.5,
    "lengthEnd": 14.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 14.0,
    "caseWidth": 12.0,
    "casesPerLayer": 11.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 13.5,
    "lengthEnd": 14.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 14.0,
    "caseWidth": 13.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Row",
    "count": 1,
    "lengthStart": 13.5,
    "lengthEnd": 14.5,
    "widthStart": 12.5,
    "widthEnd": 13.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 15.0,
    "caseWidth": 9.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 15.0,
    "caseWidth": 10.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 1,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 15.0,
    "caseWidth": 10.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 6,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 15.0,
    "caseWidth": 10.0,
    "casesPerLayer": 12.0,
    "palletPattern": "Pin Wheel",
    "count": 5,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 15.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 15.0,
    "caseWidth": 12.0,
    "casesPerLayer": 11.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 15.0,
    "caseWidth": 12.0,
    "casesPerLayer": 12.0,
    "palletPattern": "12B Offset",
    "count": 1,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 16.0,
    "caseWidth": 5.0,
    "casesPerLayer": 20.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 4.5,
    "widthEnd": 5.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 16.0,
    "caseWidth": 5.0,
    "casesPerLayer": 24.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 4.5,
    "widthEnd": 5.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 16.0,
    "caseWidth": 8.0,
    "casesPerLayer": 15.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 16.0,
    "caseWidth": 10.0,
    "casesPerLayer": 10.0,
    "palletPattern": "12B Offset",
    "count": 1,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 16.0,
    "caseWidth": 10.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 6,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 16.0,
    "caseWidth": 10.0,
    "casesPerLayer": 11.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 16.0,
    "caseWidth": 10.0,
    "casesPerLayer": 12.0,
    "palletPattern": "Pin Wheel",
    "count": 4,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 16.0,
    "caseWidth": 10.0,
    "casesPerLayer": 12.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 16.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 5,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 16.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 5,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 16.0,
    "caseWidth": 11.0,
    "casesPerLayer": 13.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 16.0,
    "caseWidth": 14.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Row",
    "count": 1,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 13.5,
    "widthEnd": 14.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 17.0,
    "caseWidth": 9.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 17.0,
    "caseWidth": 10.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 2,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 4,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 8,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 5,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 3,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 17.0,
    "caseWidth": 12.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 17.0,
    "caseWidth": 12.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 2,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 17.0,
    "caseWidth": 12.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 18.0,
    "caseWidth": 9.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 18.0,
    "caseWidth": 9.0,
    "casesPerLayer": 11.0,
    "palletPattern": "Split Row",
    "count": 3,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 18.0,
    "caseWidth": 11.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 2,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 18.0,
    "caseWidth": 12.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 18.0,
    "caseWidth": 12.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 2,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 18.0,
    "caseWidth": 12.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 18.0,
    "caseWidth": 12.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 6,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 19.0,
    "caseWidth": 9.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 19.0,
    "caseWidth": 10.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 2,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 19.0,
    "caseWidth": 10.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 11,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 19.0,
    "caseWidth": 11.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 1,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 19.0,
    "caseWidth": 12.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 3,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 19.0,
    "caseWidth": 12.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 1,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 19.0,
    "caseWidth": 12.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 19.0,
    "caseWidth": 13.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 12.5,
    "widthEnd": 13.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 20.0,
    "caseWidth": 8.0,
    "casesPerLayer": 15.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 19.5,
    "lengthEnd": 20.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 20.0,
    "caseWidth": 10.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 19.5,
    "lengthEnd": 20.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 20.0,
    "caseWidth": 10.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 7,
    "lengthStart": 19.5,
    "lengthEnd": 20.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 20.0,
    "caseWidth": 18.0,
    "casesPerLayer": 4.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 19.5,
    "lengthEnd": 20.5,
    "widthStart": 17.5,
    "widthEnd": 18.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 21.0,
    "caseWidth": 10.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 1,
    "lengthStart": 20.5,
    "lengthEnd": 21.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 21.0,
    "caseWidth": 11.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 20.5,
    "lengthEnd": 21.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5",
    "caseLength": 22.0,
    "caseWidth": 21.0,
    "casesPerLayer": 4.0,
    "palletPattern": "Row",
    "count": 1,
    "lengthStart": 21.5,
    "lengthEnd": 22.5,
    "widthStart": 20.5,
    "widthEnd": 21.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 8.0,
    "caseWidth": 4.0,
    "casesPerLayer": 48.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 7.5,
    "lengthEnd": 8.5,
    "widthStart": 3.5,
    "widthEnd": 4.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 10.0,
    "caseWidth": 5.0,
    "casesPerLayer": 36.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 9.5,
    "lengthEnd": 10.5,
    "widthStart": 4.5,
    "widthEnd": 5.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 10.0,
    "caseWidth": 5.0,
    "casesPerLayer": 40.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 9.5,
    "lengthEnd": 10.5,
    "widthStart": 4.5,
    "widthEnd": 5.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 10.0,
    "caseWidth": 7.0,
    "casesPerLayer": 22.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 9.5,
    "lengthEnd": 10.5,
    "widthStart": 6.5,
    "widthEnd": 7.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 10.0,
    "caseWidth": 7.0,
    "casesPerLayer": 24.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 9.5,
    "lengthEnd": 10.5,
    "widthStart": 6.5,
    "widthEnd": 7.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 10.0,
    "caseWidth": 7.0,
    "casesPerLayer": 26.0,
    "palletPattern": "Split Block",
    "count": 2,
    "lengthStart": 9.5,
    "lengthEnd": 10.5,
    "widthStart": 6.5,
    "widthEnd": 7.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 10.0,
    "caseWidth": 8.0,
    "casesPerLayer": 22.0,
    "palletPattern": "Brick",
    "count": 1,
    "lengthStart": 9.5,
    "lengthEnd": 10.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 10.0,
    "caseWidth": 8.0,
    "casesPerLayer": 22.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 9.5,
    "lengthEnd": 10.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 10.0,
    "caseWidth": 8.0,
    "casesPerLayer": 24.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 9.5,
    "lengthEnd": 10.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 11.0,
    "caseWidth": 7.0,
    "casesPerLayer": 24.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 10.5,
    "lengthEnd": 11.5,
    "widthStart": 6.5,
    "widthEnd": 7.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 11.0,
    "caseWidth": 8.0,
    "casesPerLayer": 20.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 10.5,
    "lengthEnd": 11.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 11.0,
    "caseWidth": 8.0,
    "casesPerLayer": 22.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 10.5,
    "lengthEnd": 11.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 11.0,
    "caseWidth": 8.0,
    "casesPerLayer": 22.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 10.5,
    "lengthEnd": 11.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 11.0,
    "caseWidth": 8.0,
    "casesPerLayer": 24.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 10.5,
    "lengthEnd": 11.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 12.0,
    "caseWidth": 9.0,
    "casesPerLayer": 16.0,
    "palletPattern": "Row",
    "count": 1,
    "lengthStart": 11.5,
    "lengthEnd": 12.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 12.0,
    "caseWidth": 9.0,
    "casesPerLayer": 16.0,
    "palletPattern": "Split Pin Wheel",
    "count": 1,
    "lengthStart": 11.5,
    "lengthEnd": 12.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 12.0,
    "caseWidth": 9.0,
    "casesPerLayer": 17.0,
    "palletPattern": "Row",
    "count": 1,
    "lengthStart": 11.5,
    "lengthEnd": 12.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 12.0,
    "caseWidth": 9.0,
    "casesPerLayer": 17.0,
    "palletPattern": "Split Row",
    "count": 4,
    "lengthStart": 11.5,
    "lengthEnd": 12.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 12.0,
    "caseWidth": 9.0,
    "casesPerLayer": 18.0,
    "palletPattern": "Split Block",
    "count": 1,
    "lengthStart": 11.5,
    "lengthEnd": 12.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 12.0,
    "caseWidth": 9.0,
    "casesPerLayer": 18.0,
    "palletPattern": "Split Pin Wheel",
    "count": 1,
    "lengthStart": 11.5,
    "lengthEnd": 12.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 12.0,
    "caseWidth": 9.0,
    "casesPerLayer": 18.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 11.5,
    "lengthEnd": 12.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 12.0,
    "caseWidth": 10.0,
    "casesPerLayer": 16.0,
    "palletPattern": "Split Pin Wheel",
    "count": 2,
    "lengthStart": 11.5,
    "lengthEnd": 12.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 12.0,
    "caseWidth": 10.0,
    "casesPerLayer": 16.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 11.5,
    "lengthEnd": 12.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 13.0,
    "caseWidth": 8.0,
    "casesPerLayer": 18.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 12.5,
    "lengthEnd": 13.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 13.0,
    "caseWidth": 9.0,
    "casesPerLayer": 15.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 12.5,
    "lengthEnd": 13.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 13.0,
    "caseWidth": 9.0,
    "casesPerLayer": 16.0,
    "palletPattern": "Split Pin Wheel",
    "count": 2,
    "lengthStart": 12.5,
    "lengthEnd": 13.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 13.0,
    "caseWidth": 10.0,
    "casesPerLayer": 15.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 12.5,
    "lengthEnd": 13.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 14.0,
    "caseWidth": 9.0,
    "casesPerLayer": 15.0,
    "palletPattern": "Split Row",
    "count": 3,
    "lengthStart": 13.5,
    "lengthEnd": 14.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 14.0,
    "caseWidth": 12.0,
    "casesPerLayer": 11.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 13.5,
    "lengthEnd": 14.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 15.0,
    "caseWidth": 8.0,
    "casesPerLayer": 15.0,
    "palletPattern": "Split Row",
    "count": 4,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 15.0,
    "caseWidth": 9.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 15.0,
    "caseWidth": 10.0,
    "casesPerLayer": 12.0,
    "palletPattern": "Pin Wheel",
    "count": 2,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 15.0,
    "caseWidth": 10.0,
    "casesPerLayer": 12.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 15.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 15.0,
    "caseWidth": 11.0,
    "casesPerLayer": 11.0,
    "palletPattern": "Split Row",
    "count": 3,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 16.0,
    "caseWidth": 8.0,
    "casesPerLayer": 15.0,
    "palletPattern": "Brick",
    "count": 1,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 16.0,
    "caseWidth": 8.0,
    "casesPerLayer": 15.0,
    "palletPattern": "Others",
    "count": 1,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 16.0,
    "caseWidth": 8.0,
    "casesPerLayer": 15.0,
    "palletPattern": "Row",
    "count": 2,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 16.0,
    "caseWidth": 8.0,
    "casesPerLayer": 15.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 16.0,
    "caseWidth": 9.0,
    "casesPerLayer": 40.0,
    "palletPattern": "Row",
    "count": 2,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 16.0,
    "caseWidth": 10.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 3,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 16.0,
    "caseWidth": 10.0,
    "casesPerLayer": 12.0,
    "palletPattern": "Pin Wheel",
    "count": 2,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 16.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Brick",
    "count": 1,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 16.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 16.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Row",
    "count": 4,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 16.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 9,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 16.0,
    "caseWidth": 14.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Block",
    "count": 1,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 13.5,
    "widthEnd": 14.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 17.0,
    "caseWidth": 10.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 2,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 6,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 17.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 17.0,
    "caseWidth": 12.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 18.0,
    "caseWidth": 11.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 1,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 18.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Others",
    "count": 1,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 18.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 6,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 18.0,
    "caseWidth": 12.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Brick",
    "count": 2,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 18.0,
    "caseWidth": 12.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 18.0,
    "caseWidth": 12.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 18.0,
    "caseWidth": 12.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 5,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 19.0,
    "caseWidth": 10.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 19.0,
    "caseWidth": 10.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 19.0,
    "caseWidth": 11.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 2,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 19.0,
    "caseWidth": 12.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 6,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 19.0,
    "caseWidth": 13.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 4,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 12.5,
    "widthEnd": 13.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 19.0,
    "caseWidth": 14.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Row",
    "count": 1,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 13.5,
    "widthEnd": 14.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 19.0,
    "caseWidth": 14.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 13.5,
    "widthEnd": 14.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 20.0,
    "caseWidth": 10.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 19.5,
    "lengthEnd": 20.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x40x5.5/5.6",
    "caseLength": 70.0,
    "caseWidth": 3.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 4,
    "lengthStart": 69.5,
    "lengthEnd": 70.5,
    "widthStart": 2.5,
    "widthEnd": 3.5
  },
  {
    "palletType": "48x41x5",
    "caseLength": 16.0,
    "caseWidth": 5.0,
    "casesPerLayer": 24.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 4.5,
    "widthEnd": 5.5
  },
  {
    "palletType": "48x42x5",
    "caseLength": 16.0,
    "caseWidth": 10.0,
    "casesPerLayer": 12.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x42x5",
    "caseLength": 16.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x43x5",
    "caseLength": 21.0,
    "caseWidth": 10.0,
    "casesPerLayer": 8.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 20.5,
    "lengthEnd": 21.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x44x5",
    "caseLength": 10.0,
    "caseWidth": 8.0,
    "casesPerLayer": 24.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 9.5,
    "lengthEnd": 10.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "48x44x6",
    "caseLength": 16.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x48x5",
    "caseLength": 15.0,
    "caseWidth": 10.0,
    "casesPerLayer": 11.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x48x5",
    "caseLength": 15.0,
    "caseWidth": 10.0,
    "casesPerLayer": 13.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 14.5,
    "lengthEnd": 15.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x48x5",
    "caseLength": 16.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 2,
    "lengthStart": 15.5,
    "lengthEnd": 16.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x48x5",
    "caseLength": 18.0,
    "caseWidth": 9.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "48x48x5",
    "caseLength": 18.0,
    "caseWidth": 11.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Pin Wheel",
    "count": 1,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 10.5,
    "widthEnd": 11.5
  },
  {
    "palletType": "48x48x5",
    "caseLength": 19.0,
    "caseWidth": 10.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 18.5,
    "lengthEnd": 19.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  },
  {
    "palletType": "48x48x5",
    "caseLength": 20.0,
    "caseWidth": 8.0,
    "casesPerLayer": 15.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 19.5,
    "lengthEnd": 20.5,
    "widthStart": 7.5,
    "widthEnd": 8.5
  },
  {
    "palletType": "56x48x5",
    "caseLength": 17.0,
    "caseWidth": 12.0,
    "casesPerLayer": 9.0,
    "palletPattern": "Split Pin Wheel",
    "count": 1,
    "lengthStart": 16.5,
    "lengthEnd": 17.5,
    "widthStart": 11.5,
    "widthEnd": 12.5
  },
  {
    "palletType": "56x48x5",
    "caseLength": 18.0,
    "caseWidth": 9.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 17.5,
    "lengthEnd": 18.5,
    "widthStart": 8.5,
    "widthEnd": 9.5
  },
  {
    "palletType": "56x48x5",
    "caseLength": 20.0,
    "caseWidth": 10.0,
    "casesPerLayer": 10.0,
    "palletPattern": "Split Row",
    "count": 1,
    "lengthStart": 19.5,
    "lengthEnd": 20.5,
    "widthStart": 9.5,
    "widthEnd": 10.5
  }
];
